var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container col-sm-12 col-md-11"},[_c('div',{staticClass:"modal-body"},[_c('button',{staticClass:"modal-default-button",on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":require("../assets/images/portfolio/exit.png")}})]),_vm._v(" "),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0e6fc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 452
// module chunks = 1